/* ============================================================
   BR CORE — minimal bootstrap the ported sections rely on.
   Replaces the parts of bella-polish.js the sections need,
   without dragging in Dawn/Sense-specific polish.
     1. sets html.br-js  (gates every scroll-reveal, so content
        is NEVER hidden if JS fails to run)
     2. exposes window.BRCart for quick-add / lookbook add-to-cart,
        auto-detecting the host theme's cart drawer.
   ============================================================ */
(function () {
  var root = document.documentElement;
  // section-styles sets window.__brEditor in the theme editor. Reveals are gated
  // behind br-js precisely so a no-JS context stays visible; the editor injects
  // section HTML via innerHTML (inline scripts never run), so it IS that context.
  if (!window.__brEditor) root.classList.add('br-js');

  // ── Preview flag, site-wide ──────────────────────────────────────
  // The app replacements (cro-cart / br-funnel / cro-quickview) stay dormant
  // unless this class is present or window.BR_LIVE names them. section-styles
  // also sets it, but only on pages that render a kit section — which is not
  // enough to trial a cart drawer or an upsell funnel. br-core.js loads on
  // every page, so setting it here makes ?br_preview=1 work everywhere.
  // Deferred scripts run in source order, so this lands before the guards.
  try {
    var qp = new URLSearchParams(location.search);
    if (qp.get('br_preview') === '1') sessionStorage.setItem('br_preview', '1');
    if (qp.get('br_preview') === '0') sessionStorage.removeItem('br_preview');
    if (sessionStorage.getItem('br_preview') === '1') root.classList.add('br-preview');
  } catch (e) {}

  function json(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then(function (r) { return r.json(); });
  }

  // Nudge whatever cart the host theme uses. Tries the common patterns in order.
  function openCart() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, [data-cart-drawer]');
    if (drawer) {
      if (typeof drawer.open === 'function') return drawer.open();
      drawer.classList.add('active', 'is-open', 'open');
      document.body.classList.add('cart-open', 'overflow-hidden');
      return;
    }
    var trigger = document.querySelector('[data-cart-drawer-toggle], .js-cart-trigger, a[href$="/cart"]');
    if (trigger) return trigger.click();
    window.location.href = '/cart';
  }

  // Ask the theme to re-render its cart; falls back to a reload-free refresh.
  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
    if (window.Shopify && window.Shopify.onCartUpdate) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(window.Shopify.onCartUpdate);
    }
  }

  if (!window.BRCart) {
    window.BRCart = {
      add: function (id, qty) {
        return json('/cart/add.js', { id: Number(id), quantity: qty || 1 }).then(function (res) {
          refresh();
          return res;
        });
      },
      refresh: refresh,
      open: openCart
    };
  }
})();


/* ── Image retry ─────────────────────────────────────────────────────
   Shopify's file CDN is intermittently returning 502/504 for this shop
   (theme assets on the same host serve fine, so it is the file-serving
   backend, not the theme). A failed <img> is permanent — the browser
   does not retry — so roughly half a grid renders as broken icons.

   Retry each failed image up to 3 times with backoff. First attempt
   re-assigns srcset, which forces a fresh fetch while keeping the
   responsive sizes; later attempts fall back to a single cache-busted
   src so a poisoned edge entry can't keep serving the error.
   ------------------------------------------------------------------ */
(function(){
  var MAX = 3;
  function retry(img){
    var n = parseInt(img.getAttribute('data-br-retry') || '0', 10);
    if (n >= MAX) { img.removeAttribute('data-br-retry'); return; }
    img.setAttribute('data-br-retry', String(n + 1));
    var srcset = img.getAttribute('data-br-srcset') || img.getAttribute('srcset') || '';
    if (srcset && !img.getAttribute('data-br-srcset')) img.setAttribute('data-br-srcset', srcset);
    var src = img.getAttribute('data-br-src') || img.getAttribute('src') || '';
    if (src && !img.getAttribute('data-br-src')) img.setAttribute('data-br-src', src);

    setTimeout(function(){
      if (n === 0 && srcset) {
        img.srcset = '';
        img.srcset = srcset;                     // re-request, keep responsive sizes
      } else if (src) {
        var bust = src.split('#')[0];
        bust += (bust.indexOf('?') > -1 ? '&' : '?') + '_brr=' + Date.now();
        img.removeAttribute('srcset');           // one plain request, no srcset picking
        img.src = bust;
      }
    }, 500 * Math.pow(2, n));                    // 0.5s, 1s, 2s
  }
  // 'error' does not bubble, so listen during capture
  document.addEventListener('error', function(e){
    var t = e.target;
    if (t && t.tagName === 'IMG') retry(t);
  }, true);
  document.addEventListener('load', function(e){
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.hasAttribute('data-br-retry')) t.removeAttribute('data-br-retry');
  }, true);
})();
